function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.20321 17.5249H11.8962C12.4042 17.5249 12.804 17.1035 12.7027 16.6056C12.4233 15.231 11.5104 12.7999 8.54969 12.7999C5.58897 12.7999 4.67614 15.231 4.39663 16.6056C4.29539 17.1035 4.69516 17.5249 5.20321 17.5249Z",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1748 12.7999C16.0457 12.7999 16.812 14.733 17.1213 16.1263C17.2884 16.8787 16.6798 17.5249 15.909 17.5249H15.0748",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5502 9.42498C9.9171 9.42498 11.0252 8.31688 11.0252 6.94998C11.0252 5.58307 9.9171 4.47498 8.5502 4.47498C7.18329 4.47498 6.0752 5.58307 6.0752 6.94998C6.0752 8.31688 7.18329 9.42498 8.5502 9.42498Z",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2754 9.42498C14.6423 9.42498 15.5254 8.31688 15.5254 6.94998C15.5254 5.58307 14.6423 4.47498 13.2754 4.47498",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.69849806e39b017569806c66794f91cb.svg";
export { ForwardRef as ReactComponent };